<div class="sidebar-container">
  <!-- TODO a unica permissao que nao foi aplciada aqui é a visualizarDashboard -->
  <div class="sidebar-modulo">
    <div class="sidebar-btn-fechar">
      <mat-icon class="btn-fechar" (click)="fechar()">close</mat-icon>
    </div>

    <div class="sidebar-texto">
      <h5>Gerenciamento de Permissões</h5>
      <p>Selecione o módulo que deseja visualizar as permisões.</p>
    </div>

    <!--# Faturas (Financeiro) -->
    <!-- <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Faturas (Financeiro)
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Demonstrativos Financeiros</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.listarDemonstrativosFinanceiros"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Exibir Detalhes de Demonstrativo Financeiro</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.exibirDetalhesDemonstrativoFinanceiro"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Fechamento</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.realizarDownloadFechamento"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div> -->

    <!--# Boletos (Financeiro) -->
    <!-- <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Boletos (Financeiro)
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Boletos</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.listarBoletos"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Boleto</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.realizarDownloadBoleto"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div> -->

    <!--# Equipamentos (Serviços) -->
    <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Equipamentos (Serviços) </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Equipamentos</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarEquipamentos"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Listagem de Equipamentos</span>
              <mat-checkbox
                [(ngModel)]="
                  permissoesPerfil.realizarDownloadListagemEquipamentos
                "
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Editar Equipamento</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.editarEquipamento"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Abrir Chamado para Equipamento</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.abrirChamadoEquipamento"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Visualizar Chamados do Equipamento</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.visualizarChamadosEquipamento"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Gerenciar QR Code de Equipamentos</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.gerenciarQrCode"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!--# Histórico de Chamados (Serviços) -->
    <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Histórico de Chamados (Serviços)
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Chamados em Andamento</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarChamadosAndamento"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Listar Chamados Finalizados</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarChamadosFinalizados"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Exibir Detalhes de Chamado</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.exibirDetalhesChamado"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!--# Novo Pedido (Suprimentos) -->
    <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Novo Pedido (Suprimentos) </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Abrir Chamado de Suprimentos</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.abrirChamadoSuprimentos"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!--# Histórico de Pedidos (Suprimentos) -->
    <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Histórico de Pedidos (Suprimentos)
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Históricos de Pedidos</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarHistoricosPedidos"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Exibir Detalhes de Pedido</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.exibirDetalhesPedido"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!--# Inventário -->
    <!-- <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Inventário
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Inventários</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.listarInventarios"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Exibir Detalhes de Inventário</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.exibirDetalhesInventario"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Alterar Posse de Inventário</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.alterarPosseInventario"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Listagem de Inventário</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.realizarDownloadListagemInventario"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div> -->

    <!--# Contratos -->
    <!-- <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Contratos
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Contratos</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.listarContratos"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Exibir Detalhes de Contrato</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.exibirDetalhesContrato"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Listagem de Contrato</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.realizarDownloadListagemContrato"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
            <div class="lista-permissoes">
              <span>Realizar Download de Equipamentos do Contrato</span>
              <mat-checkbox [(ngModel)]="permissoesPerfil.realizarDownloadEquipamentosContrato"
                (change)="habilitarSalvar()">Permitir</mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div> -->

    <!--# Usuários -->
    <div class="lista-telas">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Usuários </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="lista-permissoes">
              <span>Listar Usuários</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarUsuarios"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Listar Perfis</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.listarPerfis"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Controlar Usuários</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.controlarUsuarios"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Controlar Perfis</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.controlarPerfis"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
            <div class="lista-permissoes">
              <span>Gerenciar Permissões</span>
              <mat-checkbox
                [(ngModel)]="permissoesPerfil.gerenciarPermissoes"
                (change)="habilitarSalvar()"
                >Permitir</mat-checkbox
              >
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="sidebar-btn">
    <button
      class="button-primary btn-salvar"
      [disabled]="salvarDesabilitado"
      (click)="salvarPermissoes()"
    >
      Salvar
    </button>
  </div>
</div>
